export default {
  sections: {
    payment: 'Betaling',
  },
  labels: {
    proceed_to_payment: 'Fortsæt til betaling via link eller scan QR-koden',
  },
  buttons: {
    generate_new_link: 'Generer nyt link',
    copy_link: 'Kopiér link',
    pay_now: 'Betal nu',
  },
  toasts: {
    failed_to_create_payment_link: 'Betalingslinket kunne ikke indlæses',
  },
};
